import { Box } from '@mui/material';
import { Dispatch, FunctionComponent, SetStateAction, useState } from 'react';
import { L3ServiceLocationViewModel } from '../../model';
import { TopologyOverlayLeftColumnView } from '../Topology/Topology';
import { TopologyFilters, TopologyFilterValues } from '../TopologyFilters/TopologyFilters';
import {
  TopologyServicePositionChangeStatusSection,
} from '../TopologyServicePositionChangeStatusSection/TopologyServicePositionChangeStatusSection';
import { TopologyToolbar } from '../TopologyToolbar/TopologyToolbar';

interface Props {
  locations: L3ServiceLocationViewModel[] | null;
  filters: TopologyFilterValues;
  updateFilters: Dispatch<SetStateAction<TopologyFilterValues>>;
  clearFilters: () => void;
  leftColumnView: TopologyOverlayLeftColumnView;
  setLeftColumnView: Dispatch<SetStateAction<TopologyOverlayLeftColumnView>>;
  setDraggedItemId: (itemId: number | null) => void;
  saveNewPosition: () => void;
  restoreCoordinates: () => void;
}
export const TopologyOverlay: FunctionComponent<Props> = ({
  locations,
  clearFilters,
  filters,
  updateFilters,
  leftColumnView,
  setLeftColumnView,
  setDraggedItemId,
  saveNewPosition,
  restoreCoordinates,
}) => {
  const [filtersVisible, setFiltersVisible] = useState<boolean>(false);

  const exitChangePositionView = (): void => {
    setLeftColumnView(TopologyOverlayLeftColumnView.None);
    setDraggedItemId(null);
  };

  const restoreCoordinatedAndCloseChangePositionView = (): void => {
    restoreCoordinates();
    exitChangePositionView();
  }

  const saveNewPositionAndCloseChangePositionView = () : void => {
    saveNewPosition();
    exitChangePositionView();
  };

  return <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: { xs: 20, sm: 60 },
      background: 'transparent',
      width: '90%',
      height: '90%',
      left: '5%',
      gap: 1,
      p: '0.75rem',
    }}
  >
    <Box>
      <TopologyToolbar
        locations={locations}
        updateFilters={updateFilters}
        setFiltersVisible={setFiltersVisible}
      />
    </Box>
    <Box sx={{ display: 'flex', justifyContent: 'end', height: '100%', gap: 1 }}>
      <Box sx={{ height: '100%', width: '70%' }}>
        { leftColumnView === TopologyOverlayLeftColumnView.ServicePositionChange &&
          <TopologyServicePositionChangeStatusSection
            exitChangePositionView={ restoreCoordinatedAndCloseChangePositionView }
            saveNewPosition={ saveNewPositionAndCloseChangePositionView }
          />
        }
      </Box>
      <Box sx={{ height: '100%', width: '30%' }}>
        { filtersVisible &&
          <TopologyFilters
            filters={filters}
            clearFilters={clearFilters}
            updateFilters={updateFilters}
            closeFilters={() => {
              setFiltersVisible(false);
            }}
          />
        }
      </Box>
    </Box>
  </Box>;
};